import { formatApproximateDifferenceInHoursAndMinutes } from '@backoffice-frontend/fleet-maps-common'
import { AdConnectivityState } from '@backoffice-frontend/graphql'
import { Badge, Text } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import { CardRow } from '../CardRow'
import { CardTable } from '../CardTable'
import { CollapsibleCard } from '../CollapsibleCard'
import type { SystemComponentsCardVehicleFragment } from './SystemComponentsCard.hook'

const textStyles = {
  minWidth: 60,
  textWrap: 'nowrap',
} as const

export const SystemComponentsCard = ({
  className,
  vehicle,
}: {
  className?: string
  vehicle: SystemComponentsCardVehicleFragment
}) => {
  const { t } = useTranslation()

  const isOnline = (state?: AdConnectivityState | null) =>
    state === AdConnectivityState.Connected

  return (
    <CollapsibleCard
      className={className}
      title={t('adFleetMap_systemComponentCard_header')}
    >
      <CardTable>
        <CardRow
          label={t('adFleetMap_systemComponentCardOperatorInteraction_label')}
          state={
            isOnline(
              vehicle.latestADTelemetry?.signalConnectivityState
                ?.connectivityState,
            ) ? (
              <Text css={textStyles}>{t('common_online_label')}</Text>
            ) : (
              <Badge label={t('common_offline_label')} variant="critical" />
            )
          }
          updatedAt={
            vehicle.latestADTelemetry?.signalConnectivityState?.timestamp
              ? formatApproximateDifferenceInHoursAndMinutes(
                  new Date(
                    vehicle.latestADTelemetry.signalConnectivityState.timestamp,
                  ),
                  new Date(),
                )
              : undefined
          }
        />
        <CardRow
          label={t('adFleetMap_systemComponentCardCabinSafety_label')}
          state={
            isOnline(
              vehicle.latestADTelemetry?.cabinConnectivityState
                ?.connectivityState,
            ) ? (
              <Text css={textStyles}>{t('common_online_label')}</Text>
            ) : (
              <Badge label={t('common_offline_label')} variant="critical" />
            )
          }
          updatedAt={
            vehicle.latestADTelemetry?.cabinConnectivityState?.timestamp
              ? formatApproximateDifferenceInHoursAndMinutes(
                  new Date(
                    vehicle.latestADTelemetry.cabinConnectivityState.timestamp,
                  ),
                  new Date(),
                )
              : undefined
          }
        />
      </CardTable>
    </CollapsibleCard>
  )
}
